import { getChecksumAddressOrThrow } from "@silo/types";
import { Record, pipe } from "effect";

export const createChecksumAddressRecordOrThrow = <K extends string>(
  record: Record<K, string>
) => {
  return pipe(record, Record.map(getChecksumAddressOrThrow));
};
